import RequestsService from "./requests-service";

export default RequestsService;